<template>
  <div>
    <template v-if="selected">
      <div class="card card-select btn-light" @click="handleInputClick()">
        <div class="card-body">
          <div class="d-flex">
            <div class="flex-grow-1">
              <product-label :product="selected" />
            </div>
            <div>
              <button class="btn btn btn-light" @click.stop="handleClear()"><i class="text-info fas fa-times"></i></button>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="card" @click="handleInputClick()">
        <div class="card-body">Selecionar produto</div>
      </div>
    </template>

    <b-modal
      ref="modal"
      title="Pesquisar produto"
      header-class="border-bottom-0"
      size="lg"
      hide-footer
    >
      <template #modal-header>
        <h5>Pesquisar produto</h5>
        <b-button
          v-b-tooltip.hover
          class="text-success"
          @click="addProduct()"
          variant="outline-light"
          title="Adicionar novo produto"
        >
          <i class="fas fa-plus mr-2" /> Novo
        </b-button>       
      </template>
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <text-input
              class="ml-0"
              v-model="form.text"
              placeholder="Perquisar produto..."
              @input="select(1)"
            />
          </div>
        </div>
        <table-paginator :data="products" @pagechange="handlePageChange($event)">
          <template v-for="product in products.data">
            <div class="row py-3 row-seletable" :key="product.id" @click="handleInput(product)">
              <div class="col-md-12 d-flex">
                <div>
                  <product-label :product="product" />
                </div>
              </div>
            </div>
          </template>
        </table-paginator>
      </div>
    </b-modal>
    <ProductForm ref='ProductForm' />
  </div>
</template>

<script>

import tablePaginator from '@/components/sections/TablePaginator';
import productLabel from '@/components/product/sections/ProductLabel';
import ProductForm from "@/components/product/forms/ProductForm";      

export default {
  components: { productLabel, tablePaginator , ProductForm},

  props: {
    value: {},
    productType: {},
  },

  data: () => ({
    selected: null,

    form: {
      text: null,
      page: 1,
      product_type: ["s"],
      status: 1,
    },
    
    products : {
      data : []
    }
  }),

  async created() {
    this.selected = this.value
  },

  watch: {
    value (val) {
      this.selected = val
    }
  },

  methods: {

    async select(page = 1) {
      this.form.page = page;
      
      let response = await this.$store.dispatch("product/getProducts", this.form);

      this.products = response.products
    },

    async handleInputClick() {
      await this.select();
      this.$refs.modal.show();
    },

    handlePageChange(page) {
      this.select(page);
    },

    handleInput(product) {
      this.selected = this.parseSelectedProduct(product)
      this.$emit('input', this.selected)
      this.$refs.modal.hide();
    },

    parseSelectedProduct(product) {
      // melhorar quando for usar recurso de variante,
      // por enquanto esta sendo setado somente a primeira variavel, 
      // pois o sistema ainda não possui controle de variant
      let resultProduct = JSON.parse(JSON.stringify(product))

      resultProduct.product_variant[0].product_company = resultProduct.product_variant[0].product_company[0]
      resultProduct.product_variant = resultProduct.product_variant[0]

      return resultProduct 
    },

    handleClear() {
      this.selected = null
      this.$emit('input', this.selected)
    },
    addProduct(){
      this.$refs.ProductForm.open()
    }
  },
};
</script>

<style scoped>
.row-seletable {
  cursor: pointer;
  border-radius: 0.25rem;
  margin-left: 5px;
  margin-right: 5px;
}

.row-seletable:hover {
  background-color: rgba(0, 0, 0, 0.075);
}
/* .card-select {
  cursor: pointer;
} */

/* .card-selected {
  border-color: #8bc34a;
}

.card-selectable:hover {
  border-color: #8bc34a;
} */
</style>